/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Clipboard_EmptyInputs */

const vi_tea_purchase_payment_proof_clipboard_empty = /** @type {(inputs: Tea_Purchase_Payment_Proof_Clipboard_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có ảnh trong clipboard`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Clipboard_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_clipboard_empty = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Clipboard_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Clipboard_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_clipboard_empty(inputs)
});